import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Data, Route } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserService } from '../services';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate, CanLoad {
    constructor(
        private userService: UserService,
        private authenticationService: AuthenticationService,
    ) {}

    canLoad(route: Route): Observable<boolean> {
        return this.checkAccessRights$(route.data);
    }

    canActivate(activatedRoute: ActivatedRouteSnapshot): Observable<boolean> {
        return this.checkAccessRights$(activatedRoute.data, true);
    }

    canActivateChild(activatedRoute: ActivatedRouteSnapshot): Observable<boolean> {
        return this.checkAccessRights$(activatedRoute.data);
    }

    private checkAccessRights$(data: Data | undefined, handleNonAuthorizedRoutesOrRequests: boolean = false): Observable<boolean> {
        if (!this.authenticationService.hasValidAccessToken()) {
            if (handleNonAuthorizedRoutesOrRequests) {
                this.authenticationService.handleNonAuthorizedRoutesOrRequests();
            }
            return of(false);
        }
        return this.userService.hasPermissions$(data && data.requiredPermissions ? data.requiredPermissions : []);
    }
}
